import clsx from "clsx";
import { findMixLineupEntry } from "@/config/mixLineup";
import { resolveBoardIcon } from "@/shared/lib/boardIcon";

interface CatalogBoardIconProps {
  slug: string | undefined;
  className?: string;
}

/** mixカタログの取得元板を示す16px角の板アイコン。 */
export const CatalogBoardIcon: React.FunctionComponent<
  CatalogBoardIconProps
> = ({ slug, className }: CatalogBoardIconProps) => {
  const src = resolveBoardIcon(slug);
  if (src === null || slug === undefined) return null;

  const label = findMixLineupEntry(slug)?.label ?? slug;
  return (
    <img
      src={src}
      alt={`${label}の板`}
      title={label}
      className={clsx(
        "catalog-board-icon h-4 w-4 shrink-0 object-contain",
        className,
      )}
    />
  );
};
